/**
 * 日本の郵便番号（7桁）から住所（都道府県・市区町村・町域名）を自動検索・補完するユーティリティ
 * 無料・CORS対応の Zipcloud API を使用
 */

export interface PostalAddressResult {
  prefecture: string
  city: string
  town: string
}

export async function searchAddressByPostalCode(postalCode: string): Promise<PostalAddressResult | null> {
  if (!postalCode) return null

  // ハイフンや全角数字・スペースのクレンジング
  const cleaned = postalCode
    .replace(/[ー-]/g, '')
    .replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xfee0))
    .trim()

  if (!/^\d{7}$/.test(cleaned)) {
    return null
  }

  try {
    const response = await fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${cleaned}`)
    if (!response.ok) return null

    const data = await response.json()
    if (data.status === 200 && data.results && data.results.length > 0) {
      const result = data.results[0]
      return {
        prefecture: result.address1, // 例: 東京都
        city: result.address2,       // 例: 千代田区
        town: result.address3,       // 例: 丸の内
      }
    }
  } catch (error) {
    console.error('郵便番号検索APIエラー:', error)
  }

  return null
}
